import React  from 'react';
import HelpTopicBasicInfoComponent from './help-topic-basic-info.component';
import TabContainer from '../../../../../../common/components/tab/containers/tab.containers';


export const HelpTopicComponent = ({handleFormHelpTopicItemChange,helpTopics,mediaFiles,handleFormItemChange,deleteSelectedFile,getIsImageRecordDeletable,changeImage, handleInnerFormChange, selectedHelpTopics,back,handleFormSubmit}: any) => {
  const tabItems=[
    {
        id:1,
        title:'Help Topic Information',
        component:<HelpTopicBasicInfoComponent handleInnerFormChange={handleInnerFormChange}
        selectedHelpTopics={selectedHelpTopics}
        mediaFiles={mediaFiles}
        handleFormHelpTopicItemChange={handleFormHelpTopicItemChange}
        changeImage={changeImage}
        deleteSelectedFile={deleteSelectedFile}
        getIsImageRecordDeletable={getIsImageRecordDeletable}
        helpTopics={helpTopics}
        handleFormItemChange={handleFormItemChange}
         />,
    isVisible:true,
    },
    
  ]
    
  return (
    <>   
      <TabContainer tabItems={tabItems} />
      <div className='flex w-full justify-end items-end'>
        <button
              onClick={back}
              type='button'
              className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
             >
              Back
             </button>
             <button
            className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
              onClick={handleFormSubmit}
            
              type="submit"
          >
            Save
          </button>
        </div>
       
    </>
  )
}
export default HelpTopicComponent;
